export default __webpack_public_path__ + "static/media/m-top-bg.a479024c.png";